import script from "./album-artwork-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./album-artwork-icon.vue?vue&type=script&setup=true&lang=js"

import "./album-artwork-icon.vue?vue&type=style&index=0&id=5ce7d6ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce7d6ae"]])

export default __exports__